module.exports = "https://static.wanderu.com/static/media/it.9938f4b9.svg";